import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export type DetailStatItem = {
  icon: ReactNode;
  label: string;
  value: string;
  valueClassName?: string;
};

type DetailStatsGridProps = {
  items: DetailStatItem[];
  columns?: number;
  className?: string;
};

export function DetailStatsGrid({ items, columns, className }: DetailStatsGridProps) {
  if (items.length === 0) return null;

  const colCount = columns ?? items.length;

  return (
    <div
      className={cn("grid gap-2", className)}
      style={{ gridTemplateColumns: `repeat(${colCount}, minmax(0, 1fr))` }}
    >
      {items.map((item) => (
        <div
          key={item.label}
          className="rounded-2xl border border-border bg-surface p-2.5"
        >
          <div className="flex items-center gap-1.5">
            <span className="shrink-0 text-pulse [&>svg]:h-3.5 [&>svg]:w-3.5">{item.icon}</span>
            <span className="text-[10px] font-medium uppercase tracking-wider text-muted-foreground">
              {item.label}
            </span>
          </div>
          <p className={cn("mt-1 text-sm font-bold leading-tight", item.valueClassName)}>
            {item.value}
          </p>
        </div>
      ))}
    </div>
  );
}
